import { useCallback } from 'react';

const useGridToggleFilteredSelection = gridApi => {
  const selectAllFiltered = useCallback(() => {
    if (gridApi) {
      gridApi.selectAllFiltered();
      gridApi.refreshCells({ force: true });
    }
  }, [gridApi]);

  const unselectAllFiltered = useCallback(() => {
    if (gridApi) {
      gridApi.deselectAllFiltered();
      gridApi.refreshCells({ force: true });
    }
  }, [gridApi]);

  return {
    selectAllFiltered,
    unselectAllFiltered,
  };
};

export default useGridToggleFilteredSelection;
